import { client } from "utils";

export const getBranchesRequest = () => client.get("branches");
